var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg777(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.21229H4.02235C4.02235 8.10056 4.08939 7.57542 4.35754 6.36871C4.69274 4.86034 7.82123 6.31285 8.99441 6.36871C9.93296 6.41341 11.0987 5.64246 11.5642 5.2514C10.3352 6.42458 7.36313 9.31844 5.30726 11.5084C3.2514 13.6983 2.81192 18.0819 2.84916 20H10.3911C9.94413 15.1955 12.1788 10.3911 14.4134 7.2067C16.2011 4.65922 16.4991 1.56425 16.4246 0.335196H13.6313C13.5754 0.614525 13.2067 1.18436 12.1788 1.22905C10.8939 1.28492 9.21788 0 6.98324 0C5.19553 0 4.26443 1.26629 4.02235 1.89944V0.335196H0V8.21229Z",
    fill: "#F4EEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg777);
export default __webpack_public_path__ + "static/media/777.493351f0f52f230d46204aea05da2859.svg";
export { ForwardRef as ReactComponent };